/* VersionControlConstants.js */

"use strict";

const VERSION_CONTROL_DISPLAY_TYPES = {
    "Config Audit Policy": {
        name: "Config Audit Policy",
        title: "Config Audit Policy",
    },
    "RPA Workflow": {
        name: "RPA Workflow",
        title: "RPA Workflow",
    },
    Node: {
        name: "Node",
        title: "Node",
    },
    Feature: {
        name: "Feature",
        title: "Feature",
    },
    Global: {
        name: "Global",
        title: "Global",
    },
    Domain: {
        name: "Domain",
        title: "Domain",
    },
};

const VERSION_CONTROL_CONSTRUCTS = ["node", "feature", "global", "domain"];

module.exports = {
    VERSION_CONTROL_DISPLAY_TYPES,
    VERSION_CONTROL_CONSTRUCTS,
};
